const ValsaborTheme = {
    images : {
        loginLogo: "/img/valsabor/login-logo.png",
        whiteLogo: "/img/valsabor/login-logo.png",
        favicon: "/img/valsabor/favicon.ico",
        leftMenuLogo: "/img/valsabor/logo-only.png",

        touchIconIphone: "/img/touch-icon-iphone.png",
        touchIconIpad:"/img/touch-icon-ipad.png",
        touchIconIphoneRetina: "/img/touch-icon-iphone-retina.png",
        touchIconIpadRetina: "/img/touch-icon-ipad-retina.png",
        appleTouchStartupImage: "/img/apple-touch-startup-image"
    },
    css: [
        "/themes/valsabor/valsabor.css"
    ],
    strings: {
        title: "Valsabor - Product Monitorization"
    }
}

export default ValsaborTheme;